module.exports = "../../static/fonts/Simple-Line-Icons.f33df36.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = 174
// module chunks = 0